import React, { FC } from "react";
import { faEllipsis } from "@fortawesome/pro-regular-svg-icons/faEllipsis";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const ThreeDots: FC<JSX.IntrinsicAttributes> = (props) => (
  <FontAwesomeIcon icon={faEllipsis} {...props} />
);
